import { type CollectionConfig, CollectionLayout, CollectionSlug } from '../collections.types';

const IMAGES = 'https://p1.liveauctioneers.com/dist/images/fine-jewelry-and-watches';

export const jewelryCollection: CollectionConfig = {
    breadcrumbs: [
        { href: '/c/jewelry/', label: 'Jewelry' },
        { href: '', label: 'Fine Jewelry' },
    ],
    description:
        'Shop luxury pieces from Tiffany & Co., Van Cleef & Arpels, Rolex, Cartier, Chanel and Hermès, all in one place.',
    layout: CollectionLayout.Collection,
    metaDescription:
        'Shop fine jewelry and luxury watches at auction — Tiffany & Co., Van Cleef & Arpels, Rolex, Cartier, Chanel and Hermès from top auction houses worldwide.',
    searchParams: { category_id: '6', keyword: 'fine', status: 'online' },
    seoTitle: 'Fine Jewelry & Watches for Sale at Auction',
    slug: CollectionSlug.Jewelry,
    subcategories: [
        {
            href: '/search/?category_id=6&keyword=tiffany&sale_type=liveAuction&status=online',
            imageUrl: `${IMAGES}-tiffany-n-co.png`,
            title: 'Tiffany & Co.',
        },
        {
            href: '/search/?category_id=6&keyword=cartier&sale_type=liveAuction&status=online',
            imageUrl: `${IMAGES}-cartier.png`,
            title: 'Cartier',
        },
        {
            href: '/search/?keyword=van%20cleef&sale_type=liveAuction&status=online',
            imageUrl: `${IMAGES}-van-cleef-n-arpels.png`,
            title: 'Van Cleef & Arpels',
        },
        {
            href: '/search/?category_id=6&keyword=chanel&sale_type=liveAuction&status=online',
            imageUrl: `${IMAGES}-channel.png`,
            title: 'Chanel',
        },
        {
            href: '/search/?keyword=rolex&sale_type=liveAuction&status=online',
            imageUrl: `${IMAGES}-rolex.png`,
            title: 'Rolex',
        },
        {
            href: '/search/?category_id=6&keyword=hermes&sale_type=liveAuction&status=online',
            imageUrl: `${IMAGES}-hermes.png`,
            title: 'Hermes',
        },
    ],
    title: 'Fine Jewelry & Watches',
};
